import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { deleteRole, getRoles } from "src/api/settings";
import CustomConfirmDialog from "src/components/CustomConfirmDialog";
import CustomDataTable from "src/components/CustomDataTable";
import CustomDropdown, { dropdownActionVariants } from "src/components/CustomDropdown";
import CustomSheet from "src/components/CustomSheet";
import CreateRole from "src/components/modals/CreateRole";
import PermissionWrapper from "src/components/PermissionWrapper";
import { Button } from "src/components/ui/button";
import useHasPermissions from "src/hooks/useHasPermissions";
import { showSuccessToast } from "src/lib/utils";
import { EllipsisIcon } from "src/svg";
import "src/array";

const RoleSettings = () => {
	const hasEditPermission = useHasPermissions("update_role");
	const hasDeletePermission = useHasPermissions("delete_role");
	const queryClient = useQueryClient();

	const { data, isLoading } = useQuery({
		queryKey: ["roles"],
		queryFn: () => getRoles(),
	});
	const { mutate: deleteRoleMutate } = useMutation(deleteRole, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			queryClient.invalidateQueries(["roles"]);
		},
	});

	const columns = [
		{ name: "S/N", selector: (_, index) => index + 1, width: "150px" },
		{ name: "Name", selector: (row) => row.name, style: { textTransform: "capitalize" }, grow: 1.5 },
		{
			name: "Action",
			cell: (row) => (
				<CustomDropdown
					trigger={
						<Button variant="hover">
							<EllipsisIcon />
						</Button>
					}
					actions={[]
						.appendToArray(
							[
								{
									label: (
										<CustomSheet title="Edit Role" trigger={<span>Edit Role</span>}>
											<CreateRole role={row} />
										</CustomSheet>
									),
									asChild: true,
								},
							],
							hasEditPermission
						)
						.appendToArray(
							[
								{
									label: (
										<CustomConfirmDialog
											trigger={<span className={dropdownActionVariants({ variant: "destructive" })}>Delete Role</span>}
											mutateFn={() => deleteRoleMutate({ uuid: row.uuid })}
										/>
									),
									asChild: true,
								},
							],
							hasDeletePermission
						)}
				/>
			),
			maxWidth: "70px",
		},
	];
	const roles = data?.data;

	return (
		<div className="settings_cont_ins">
			<div className="pageTop tw-flex tw-items-center tw-justify-between">
				<h2>Roles</h2>
				<PermissionWrapper permission="add_role">
					<div className="">
						<CustomSheet title="Create Role" trigger={<Button className="!tw-rounded-full !tw-py-2">Create Role</Button>}>
							<CreateRole />
						</CustomSheet>
					</div>
				</PermissionWrapper>
			</div>

			<div className="innerContent">
				<CustomDataTable data={roles} progressPending={isLoading} columns={columns} />
			</div>
		</div>
	);
};

export default RoleSettings;
